import { Component } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import { ConfigurationRestWebZipcodePage } from '../../../configuration/configuration-rest-web/configuration-rest-web-zipcode/configuration-rest-web-zipcode';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-shipment',
    templateUrl: 'ods-config-shipment.html',
})
export class OdsConfigShipmentPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices,
        private modalCtrl: ModalController) {
    }

    editZipCodes() {
        let profileModal = this.modalCtrl.create(ConfigurationRestWebZipcodePage, {
            zip_codes: this.odsServices.zip_codes
        });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.odsServices.zip_code_show = '';
                data.forEach(code => {
                    this.odsServices.zip_code_show += code.code + ',';
                });
            }
        });
        profileModal.present();
    }

    next() {
        //Guardamos las variables
        this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            web_pickup: this.globals.restaurant.web_pickup || false,
            web_delivery: this.globals.restaurant.web_delivery || false,
            web_tk_min_order: this.globals.restaurant.web_tk_min_order || 0,
            web_sending_price: this.globals.restaurant.web_sending_price || 0,
            web_free_sending: this.globals.restaurant.web_free_sending || 0,
            web_aprox_delivery_time: this.globals.restaurant.web_aprox_delivery_time || ''
        });
        //
        this.globals.restaurant.web_pickup = this.globals.restaurant.web_pickup || false;
        this.globals.restaurant.web_delivery = this.globals.restaurant.web_delivery || false;
        this.globals.restaurant.web_tk_min_order = this.globals.restaurant.web_tk_min_order || 0;
        this.globals.restaurant.web_sending_price = this.globals.restaurant.web_sending_price || 0;
        this.globals.restaurant.web_free_sending = this.globals.restaurant.web_free_sending || 0;
        this.globals.restaurant.web_aprox_delivery_time = this.globals.restaurant.web_aprox_delivery_time || '';
        //
        if (!this.odsServices.takeaway_config.config_shipment) {
            this.odsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                config_shipment: true
            });
            this.odsServices.takeaway_config.config_shipment = true;
        }
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-shipment/ods-config-shipment.ts